<template>
  <div id="SearchIndex">
    <div class="searchDiv">
      <div class="class_Box aqt_su">
        <div class="class_Item aqt_su" v-if="typeclassList.includes(1)">
          <p class="title_model aqt_lang_mn titlefont">{{$t('m.book_title')+' '+':'|U2M}}</p>
          <div class="aqt_lang_mn titlefont"
               :class="item.components==Components&&item.typeClass==type_class&&item.key==key_class&&item.value==value_class?'active':'label'"
               v-for="(item,index) in list_1" :key="index" @click="getType(item)">
            {{ item.titlelang.mn|U2M }}
          </div>
          <Select ref="culture_select" @on-change="getCulturalClass" transfer-class-name="transfer_index_search" label-in-value class="labelSub"
                  v-model="culture_id" @on-clear="onClear"
                  clearable filterable
                  :placeholder="$t('m.CulturalClass')|U2M">
            <Option v-for="(item,index) in CulturalClassList" :value="item.value" :key="index">{{ item.text ? item.text.trim() : '' }}</Option>
          </Select>

          <Select ref="resour_select" @on-change="getResourClass" transfer-class-name="transfer_index_search" label-in-value class="labelSub"
                  v-model="resourceclass_id" clearable  @on-clear="onClear"
                  filterable
                  :placeholder="$t('m.ResourceClass')|U2M">
            <Option v-for="(item,index) in ResourceClassList" :value="item.value" :key="index">{{ item.text ? item.text.trim() : '' }}</Option>
          </Select>

          <div style="clear: both"></div>
        </div>
        <div class="class_Item aqt_su" v-if="typeclassList.includes(2)">
          <div class="aqt_lang_mn titlefont"
               :class="item.components==Components&&item.typeClass==type_class&&item.key==key_class&&item.value==value_class?'active':'label'"
               v-for="(item,index) in list_2" :key="index" @click="getType(item)">
            {{ item.titlelang.mn|U2M }}
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="class_Item aqt_su" v-if="typeclassList.includes(3)">
          <div class="aqt_lang_mn titlefont"
               :class="item.components==Components&&item.typeClass==type_class&&item.key==key_class&&item.value==value_class?'active':'label'"
               v-for="(item,index) in list_3" :key="index" @click="getType(item)">
            {{ item.titlelang.mn|U2M }}
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="class_Item aqt_su" v-if="typeclassList.includes(4)">
          <div class=" aqt_lang_mn titlefont"
               :class="item.components==Components&&item.typeClass==type_class&&item.key==key_class&&item.value==value_class?'active':'label'"
               v-for="(item,index) in list_4" :key="index" @click="getType(item)">
            {{ item.titlelang.mn|U2M }}
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="class_Item aqt_su" v-if="typeclassList.includes(5)">
          <p class="title_model aqt_lang_mn titlefont">{{$t('m.periodical_')+' '+':'|U2M}}</p>
          <div class=" aqt_lang_mn titlefont"
               :class="item.components==Components&&item.typeClass==type_class&&item.key==key_class&&item.value==value_class?'active':'label'"
               v-for="(item,index) in list_5" :key="index" @click="getType(item)">
            {{ item.titlelang.mn ? item.titlelang.mn : item.titlelang.zh | U2M }}
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="class_Item aqt_su" v-if="typeclassList.includes(6)">
          <div class=" aqt_lang_mn titlefont"
               :class="item.components==Components&&item.typeClass==type_class&&item.key==key_class&&item.value==value_class?'active':'label'"
               v-for="(item,index) in list_6" :key="index" @click="getType(item)">
            {{ item.titlelang.mn|U2M }}
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="class_Item aqt_su" v-if="typeclassList.includes(7)">
          <p class="title_model aqt_lang_mn titlefont">{{$t('m.dictionary')+' '+':'|U2M}}</p>
          <Select ref="StartLanguage_select" @on-select="onStartSelect" transfer-class-name="transfer_index_search" style="height: 180px" class="labelSub"
                  v-model="startlanguage" filterable clearable
                  :placeholder="$t('m.start_tc_lang')|U2M">
            <Option v-for="(item,index) in startLangList" :value="item.alis" :key="index">{{ item.name_lang.mn ? item.name_lang.mn : (item.name_lang.zh ? item.name_lang.zh : '') }}</Option>
          </Select>

          <Select ref="EndLanguage_select" @on-select="onEndSelect" transfer-class-name="transfer_index_search" style="height: 180px" class="labelSub"
                  v-model="endlanguage" filterable clearable
                  :placeholder="$t('m.end_js_lang')|U2M">
            <Option v-for="(item,index) in endLangList" :value="item.alis" :key="index+898">{{ item.name_lang.mn ? item.name_lang.mn : (item.name_lang.zh ? item.name_lang.zh : '') }}</Option>
          </Select>
          <div style="clear: both"></div>
        </div>
        <div class="class_Item aqt_su" v-if="typeclassList.includes(8)">
          <div class="aqt_lang_mn titlefont"
               :class="item.components==Components&&item.typeClass==type_class?'active':'label'"
               v-for="(item,index) in list_8" :key="index" @click="getType(item)">
            {{ item.titlelang.mn|U2M }}
          </div>
          <div v-if="!untype&&$route.path!='/aqt'&&$route.path!='/External'&&type_class==8" class="left_right left_left_hovr"
               style="color:#FFB600;background: var(--themeColor);width: 34px" @click="getMore(true)">
            <i class="iconfont icondouble-arrow-left-full"></i>
          </div>
          <div v-if="untype&&$route.path!='/aqt'&&$route.path!='/External'&&type_class==8" class="left_right left_right_hovr"
               style="color:var(--themeColor);width: 34px" @click="getMore(false)">
            <i class="iconfont icondouble-arrow-right-full"></i>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>

      <div v-if="($route.path=='/SearchIndex'&&type_class!=8)||$route.path=='/aqt'||$route.path=='/External'" class="search_Box">
        <!--除了期刊的检索-->
        <div v-if="type_class!=5" class="textareadiv titlefont" :class="startlanguage=='zh'?'aqt_su':'aqt_lang_mn'"
             :style="{height:type_class&&$route.path!='/aqt'&&$route.path!='/External'?'calc(100% - 12rem)':'calc(100% - 6rem)',display:startlanguage=='zh'?'':'flex'}">
        <textarea @keydown="getFsong($event,'other')" v-model="searchContent"
                  @blur="blurSect"></textarea>
        </div>
        <div v-if="type_class!=5" class="icon_s" @click="getSearch(true)">
          <Icon type="ios-search"/>
        </div>


        <template v-if="type_class==5&&(isComponents=='LayPeriodicalJournal'||isComponents=='LayListJournal')" >
          <!--期刊检索-->
          <Select @on-change="onField"
                  transfer-class-name="transfer_index_search" style="height: 18rem" class="JMlabelSub aqt_su"
                  v-model="fieldKey" filterable  :placeholder="$t('m.selectType')|U2M">
            <Option  v-for="(item,index) in jmfield" :value="item.key" :key="index" >{{ item.titlelang.mn ? item.titlelang.mn : (item.titlelang.zh ? item.titlelang.zh : '') }}</Option>
          </Select>
        </template>
        <template v-if="type_class==5&&isComponents=='LayAllJournalList'">
          <Select @on-change="onField"
                  transfer-class-name="transfer_index_search" style="height: 18rem" class="JMlabelSub aqt_su"
                  v-model="fieldKey" filterable  :placeholder="$t('m.selectType')|U2M">
            <Option v-for="(it,index) in mzfield" :value="it.key" :key="it.key">{{ it.titlelang.mn ? it.titlelang.mn : (it.titlelang.zh ? it.titlelang.zh : '') }}</Option>
          </Select>
        </template>
        <div v-if="type_class==5" class="textareadiv titlefont aqt_lang_mn"
             :style="{height:'calc(100% - 31rem)',display: 'flex'}">
        <textarea @keydown="getFsong($event,'jm')" v-model="searchContent"
                  @blur="blurSect"></textarea>
        </div>
        <div v-if="type_class==5" class="icon_s" @click="getJournalSearch(true)">
          <Icon type="ios-search"/>
        </div>



        <div v-if="!untype&&$route.path!='/aqt'&&$route.path!='/External'&&type_class" class="left_right left_left_hovr"
             style="color:#FFB600;background: var(--themeColor)" @click="getMore(true)">
          <i class="iconfont icondouble-arrow-left-full"></i>
        </div>
        <div v-if="untype&&$route.path!='/aqt'&&$route.path!='/External'&&type_class" class="left_right left_right_hovr"
             style="color:var(--themeColor)" @click="getMore(false)">
          <i class="iconfont icondouble-arrow-right-full"></i>
        </div>

      </div>
       <!--  期刊、杂志分类 首字母-->
      <div v-if="type_class==5" class="class_jm_Box aqt_su">
        <div class="class__jm_Item aqt_no_su">
          <div class="aqt_lang_mn titlefont"
               :class="item.magazineclass_id==magazineclassId?'activejm':'labeljm'"
               v-for="(item,index) in JournalClass" :key="index" @click="getJmType(item,'class')">
            {{ item.titlelang.mn||item.titlelang.zh|U2M }}
          </div>
          <div style="clear: both"></div>
        </div>
        <div v-if="Components == 'LayAllJournalList'" class="class__jm_Item aqt_no_su">
          <div class="aqt_lang_mn titlefont"
               :class="item.id==keymnId?'activejm':'labeljm'"
               v-for="(item,index) in InitialList" :key="item.id" @click="getJmType(item,'keymn')">
            {{ item.titlelang ? item.titlelang.mn || item.titlelang.zh : "" |U2M }}
          </div>
          <div style="clear: both"></div>
        </div>

      </div>
    </div>
    <div class="mainDiv" v-if="$route.path!='/aqt'&&$route.path!='/External'">
      <component v-if="show" :is="isComponents" ref="child" @getToDeatils="getToDeatils" @pushTele="pushTele"
                 @goJournal="goJournal" @getWidth="getWidth"></component>
      <aqt-sidebar-mn v-model="showsidebar" :title="titleStr" slot="others" class="aqt_su" :width="100">
        <component class="aqt_no_su" :is="which_to_show" :directoryId="directoryId" :infoId="infoId"></component>
      </aqt-sidebar-mn>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  components: {
    JournalDetails: (re) => require(['@/views/Journal/MN/JournalDetails.vue'], re),//期刊详情
    AuthorDetails: (re) => require(['@/views/Author/MN/AuthorDetails.vue'], re),//期刊详情
    BookDetails: (re) => require(['@/views/Books/MN/BookDetails.vue'], re),//期刊详情
    NewspapersDetais: (re) => require(['@/views/Newspapers/MN/NewspapersDetais.vue'], re),//期刊详情
    QuestionBankDetails: (re) => require(['@/views/QuestionBank/MN/QuestionBankDetails.vue'], re),//期刊详情

  },
  data() {
    return {
      list_1: [
        {
          titlelang: {
            mn: this.$t('m.book_name'),
            zh: '书名',
          },
          components: 'LayListBooks',
          typeClass: 1,
          key: 'name',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.isbn'),
            zh: '书号',
          },
          components: 'LayListBooks',
          typeClass: 1,
          key: 'isbn',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.introduce'),
            zh: '简介',
          },
          components: 'LayListBooks',
          typeClass: 1,
          key: 'content',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.press'),
            zh: '出版社',
          },
          components: 'LayListBooks',
          typeClass: 1,
          key: 'press_name',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.press_time'),
            zh: '出版时间',
          },
          components: 'LayListBooks',
          typeClass: 1,
          key: 'publish_date_chu',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.author'),
            zh: '作者',
          },
          components: 'LayListBooks',
          typeClass: 1,
          key: 'author',
          value: ''
        },
      ],
      list_2: [

        {
          titlelang: {
            mn: this.$t('m.book_catalogue'),
            zh: '书（目录）',
          },
          components: 'LayCatalogDatabase',
          typeClass: 2,
          key: 'type',
          value: 1
        },
        {
          titlelang: {
            mn: this.$t('m.periodical'),
            zh: '期刊（目录）',
          },
          components: 'LayCatalogDatabase',
          typeClass: 2,
          key: 'type',
          value: 2
        },
        {
          titlelang: {
            mn: this.$t('m.newspaper_catalogue'),
            zh: '报刊（目录）',
          },
          components: 'LayCatalogDatabase',
          typeClass: 2,
          key: 'type',
          value: 3
        },
        {
          titlelang: {
            mn: this.$t('m.paper'),
            zh: '论文（目录）',
          },
          components: 'LayCatalogDatabase',
          typeClass: 2,
          key: 'type',
          value: 4
        },
      ],
      list_3: [
        {
          titlelang: {
            mn: this.$t('m.book_paper_author'),
            zh: '作者',
          },
          components: 'LayAuthor',
          typeClass: 3,
          key: 'name',
          value: ''
        },
      ],
      list_4: [
        {
          titlelang: {
            mn: this.$t('m.proverb'),
            zh: '谚语',
          },
          components: 'LayListChineseCulture',
          typeClass: 4,
          key: 'class_id',
          value: 152,//152 谚语 151对联 153谜语
        },
        {
          titlelang: {
            mn: this.$t('m.riddle'),
            zh: '谜语',
          },
          components: 'LayListChineseCulture',
          typeClass: 4,
          key: 'class_id',
          value: 153,//152 谚语 151对联 153谜语
        },
        {
          titlelang: {
            mn: this.$t('m.couplet'),
            zh: '对联',
          },
          components: 'LayListChineseCulture',
          typeClass: 4,
          key: 'class_id',
          value: 151,//152 谚语 151对联 153谜语
        },
        {
          titlelang: {
            mn: this.$t('m.knowledge_database'),
            zh: '知识数据库',
          },
          components: 'LayQuestionBank',
          typeClass: 4,
          key: 'title',
          value: ''
        },
      ],
      list_5: [
        // {
        //   titlelang: {
        //     mn: this.$t('m.periodical_'),
        //     zh: '期刊',
        //   },
        //   components: 'LayListJournal',
        //   typeClass: 5,
        //   key: 'title',
        //   value: ''
        // },
        {
          titlelang: {
            mn: this.$t('m.allperiodical_'),
            zh: '全部杂志',
          },
          components: 'LayAllJournalList',
          typeClass: 5,
          key: 'magazineclass_id',
          value: 0
        },
      ],
      list_6: [
        {
          titlelang: {
            mn: this.$t('m.newspaper_periodicals'),
            zh: '报刊',
          },
          components: 'LayListNewspapers',
          typeClass: 6,
          key: 'title',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.Latest_news'),
            zh: '最新新闻',
          },
          components: 'LayListNewspapers',
          typeClass: 6,
          key: 'isnow',
          value: true
        },

      ],
      list_7: [
        {
          titlelang: {
            mn: this.$t('m.dictionary_fanyi'),
            zh: '词典数据库（翻译）',
          },
          components: 'LayTranslate',
          typeClass: 7,
          key: 'title'
        },
      ],
      list_8: [
        {
          titlelang: {
            mn: this.$t('m.intelligent_translation'),
            zh: '智能翻译',
          },
          components: 'LayIntarTranslate',
          typeClass: 8,
          key: 'title',
          value: ''
        },
      ],
      queryList: [
        {
          name: '',
          isbn: '',
          content: '',
          press_name: '',
          publish_date_chu: '',
          author: '',
          culture_id: '',
          resourceclass_id: '',
          press_id: '',
        },
        {
          title: '',
          type: 0,//1.书2.期刊3、报刊、4论文
        },
        {
          type: 1,//1作者 2歌手 3医生 4评委
          name: '',//书名
        },
        {
          title: '',//书名
          class_id: '',//152 谚语 151对联 153谜语
          classify_id: ''
        },
        {
          magazine_id: '',//杂志iD
          magazineclass_id: '',//杂志分类id
          type:'all',//all 全部期刊列表 全部杂志入口  one树状杂志 当前馆藏杂志
        },
        {
          title: '',
          isnow: '',
        },
        {
          title: "",
          language: '',//开始语言
          conlanguage: '',//结束语言
        },
        {
          title: "",
        }
      ],
      CulturalClassList: [],//文化分类列表
      ResourceClassList: [],//资源分类列表

      startLangList: [
        {
          alis: 'mn',
          name_lang: {
            mn: this.$t('m._Mongolian'),
            zh: '蒙古语',
          }
        },
        {
          alis: 'zh',
          name_lang: {
            mn: this.$t('m._Chinese'),
            zh: '中文',
          }
        }
      ],//头词语言
      endLangList: [
        {
          alis: 'mn',
          name_lang: {
            mn: this.$t('m._Mongolian'),
            zh: '蒙古文',
          }
        },
        {
          alis: 'zh',
          name_lang: {
            mn: this.$t('m._Chinese'),
            zh: '中文',
          }
        },
        {
          alis: 'en',
          name_lang: {
            mn: this.$t('m._English'),
            zh: '英文',
          }
        }
      ],//解释语言

      culture_id: '',
      resourceclass_id: '',
      startlanguage: '',
      endlanguage: '',

      key_class: '',
      value_class: '',
      type_class: '',
      searchContent: '',
      untype: false,
      Components: '',
      isComponents: '',
      typeclassList: [1, 2, 3, 4, 5, 6, 7,8],
      show: false,

      showsidebar: false,
      titleStr: '',
      which_to_show: '',
      infoId: '',
      directoryId:'',

      JournalClass:[],//期刊分类
      InitialList:[],//首字母列表
      JournalCond:{
        title: '',
        keyword:'',//关键词
        issn:'',
        editor:'',//主编
        deputy_editor:'',//副主编

        keymn:'',//首字母
        magazineclass_id:'',//分类id
        type:'',//all 全部期刊列表 全部杂志入口  one树状杂志 当前馆藏杂志

        magazine_id: '',//杂志iD
      },
      jmfield:[
        {
          titlelang:{
            mn:this.$t('m.journal_name')+' / '+this.$t('m.qishu')+' / ' +this.$t('m.mazy_autor'),
            zh:'期刊名称',
          },
          key:'title',
        },
        {
          titlelang:{
            mn:this.$t('m.journal_keyword'),
            zh:'期刊关键词',
          },
          key:'keyword'
        },
        {
          titlelang:{
            mn:'ISSN',
            zh:'ISSN',
          },
          key:'issn'
        },
        {
          titlelang:{
            mn:this.$t('m.editor'),
            zh:'主编',
          },
          key:'editor'
        },
        {
          titlelang:{
            mn:this.$t('m.fu_editor'),
            zh:'副主编',
          },
          key:'deputy_editor'
        },
      ],
      mzfield:[
        {
          titlelang:{
            mn:this.$t('m.mazy_title'),
            zh:'杂志名称',
          },
          key:'title'
        },
        {
          titlelang:{
            mn:'ISSN',
            zh:'ISSN',
          },
          key:'issn'
        },
      ],
      fieldKey:'title',//期刊/杂志检索时的key
      keymnId:'',//首字母
      magazineclassId:'',//分类id



    }
  },
  methods: {
    //选择类型
    getType(item) {
      let that = this
      that.key_class = item.key
      that.value_class = item.value
      that.type_class = item.typeClass
      that.Components = item.components

      that.culture_id = ''
      that.resourceclass_id = ''
      that.startlanguage = ''
      that.endlanguage = ''
      if (that.$refs.culture_select) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }

      if (that.$refs.StartLanguage_select) {
        that.$refs.StartLanguage_select.setQuery(null)
      }
      if (that.$refs.EndLanguage_select) {
        that.$refs.EndLanguage_select.setQuery(null)
      }
      const emptyObj = Object.keys(that.queryList[that.type_class - 1]).reduce((obj, key) => {
        if(that.type_class==5&&key=='type'&&that.Components == 'LayPeriodicalJournal'){
          obj[key] = 'one';
        }else {
          obj[key] = '';
        }
        return obj;
      }, {});
      that.queryList[that.type_class - 1] = {...emptyObj};
      if ((that.type_class == 6 && that.key_class == 'isnow')
          || (that.type_class == 5 && (that.Components == 'LayAllJournalList' || that.Components == 'LayPeriodicalJournal'))
          ||that.type_class == 8
      ) {

        that.searchContent = ''
        that.fieldKey = 'title'
        const emptyObj = Object.keys(that.JournalCond).reduce((obj, key) => {
          if(key=='magazine_id'){

          }else {
            obj[key] = '';
          }

          return obj;
        }, {});
        that.JournalCond = {...emptyObj};
        that.keymnId = ''//首字母
        if(that.Components == 'LayAllJournalList'){
          that.magazineclassId = item.value//分类id
          that.JournalCond.magazineclass_id = item.value
        }else {
          that.magazineclassId = ''
        }
        that.getSearch()
      }
    },
    blurSect(data) {
      // this.searchContent = this.$getOnBlur(data.target.value)
      this.searchContent = data.target.value
    },
    //解决textarea回车换行不出发时间
    getFsong(e,type) {
      if (e.keyCode == 13 && e.ctrlKey) {
        document.getElementById("a").value += "\n";
      } else if (e.keyCode == 13) {
        // 避免回车键换行
        e.preventDefault();
        // 下面写你的发送消息的代码
        if(type=='other'){
          this.getSearch(true)
        }else if(type=='jm'){
          this.getJournalSearch(true)
        }

      }

    },
    //点击搜索按钮
    getSearch(isTip = false) {
      let that = this
      if(isTip){
        if(!that.searchContent){
          that.$Message.warning(that.$t('m.content_Please'))
          return;
        }
      }

      if (!that.type_class) {
        that.$Message.warning(that.$t('m.selectType'))
        return
      }
      if (that.type_class == 7 && !that.startlanguage) {
        that.$Message.warning(that.$t('m.please_start_lang'))
        return;
      }
      if (!that.searchContent && that.key_class != 'isnow' && that.Components != 'LayAllJournalList'
          && that.Components != 'LayPeriodicalJournal' && that.Components != 'LayIntarTranslate') {
        that.$Message.warning(that.$t('m.content_Please'))
        return
      }



      that.showsidebar = false//关闭详情弹框
      if (that.$route.path == '/aqt'||that.$route.path=='/External') {
        let query = {
          key_class: that.key_class,
          value_class: that.value_class,
          type_class: that.type_class,
          Components: that.Components,
          searchContent: that.searchContent,
          startlanguage: that.startlanguage,
          endlanguage: that.endlanguage
        }
        that.$router.push({
          path: '/SearchIndex',
          query: {
            lib_type:sessionStorage.getItem('gcm'),
            data:that.$crypto.set(JSON.stringify(query)),
          }
        })
        that.$loginPd()
      } else {
        that.isComponents = that.Components
        that.show = true
        if (that.type_class == 1) {
          const emptyObj = Object.keys(that.queryList[that.type_class - 1]).reduce((obj, key) => {
            if(that.type_class==5&&key=='type'&&that.Components == 'LayPeriodicalJournal'){
              obj[key] = 'one';
            }else {
              obj[key] = '';
            }
            return obj;
          }, {});
          if (that.key_class == 'culture_id' || that.key_class == 'resourceclass_id') {
            that.queryList[that.type_class - 1] = {...emptyObj, [that.key_class]: that.value_class};
          } else {
            that.queryList[that.type_class - 1] = {...emptyObj, [that.key_class]: that.searchContent};
          }
        }
        else if (that.type_class == 2) {
          that.queryList[that.type_class - 1][that.key_class] = that.value_class
          that.queryList[that.type_class - 1].title = that.searchContent
        }
        else if (that.type_class == 3) {
          that.queryList[that.type_class - 1][that.key_class] = that.searchContent
          that.queryList[that.type_class - 1].type = 1
        }
        else if (that.type_class == 4) {
          if (that.key_class == 'class_id') {
            that.queryList[that.type_class - 1][that.key_class] = that.value_class
            that.queryList[that.type_class - 1].title = that.searchContent
          } else {
            that.queryList[that.type_class - 1][that.key_class] = that.searchContent
          }
        }
        else if (that.type_class == 5) {
          // if (that.Components == 'LayListJournal') {
          //   that.queryList[that.type_class - 1][that.key_class] = that.searchContent
          // } else
          if (that.Components == 'LayAllJournalList') {
            that.queryList[that.type_class - 1].title = ''
            that.queryList[that.type_class - 1][that.key_class] = that.value_class
          } else if (that.Components == 'LayPeriodicalJournal') {
            that.queryList[that.type_class - 1][that.key_class] = that.searchContent
          }
        }
        else if (that.type_class == 6) {
          if (that.key_class == 'title') {
            that.queryList[that.type_class - 1][that.key_class] = that.searchContent
            that.queryList[that.type_class - 1].isnow = ''
          } else {
            that.queryList[that.type_class - 1].isnow = true
            that.queryList[that.type_class - 1].title = that.searchContent
          }
        }
        else if (that.type_class == 7) {
          that.queryList[that.type_class - 1].title = that.searchContent
          that.queryList[that.type_class - 1].language = that.startlanguage
          that.queryList[that.type_class - 1].conlanguage = that.endlanguage
        }
        setTimeout(function () {
          that.$refs.child.ParentCom(that.queryList[that.type_class - 1]);
          that.$loginPd()
        }, 500)

      }
    },


    //点击期刊搜索
    getJournalSearch(isTip = false){
      let that = this
      if(isTip){
        if(!that.searchContent){
          that.$Message.warning(that.$t('m.content_Please'))
          return;
        }
        if (!that.fieldKey) {
          that.$Message.warning(that.$t('m.selectType'))
          return
        }
      }

      that.JournalCond[that.fieldKey] = that.searchContent


      setTimeout(function () {
       if(that.Components == 'LayPeriodicalJournal'){
          that.JournalCond.type ='one'
        }
        that.$refs.child.ParentCom(that.JournalCond);
        that.$loginPd()
      }, 500)
    },
    //期刊杂志选择检索类型
    onField(val){
      let that = this
      const emptyObj = Object.keys(that.JournalCond).reduce((obj, key) => {
        if(key=='keymn'){
          obj[key] = that.keymnId;
        }else if(key=='magazineclass_id'){
          obj[key] = that.magazineclassId;
        }else if(key=='magazine_id'){
          obj[key] = that.queryList[that.type_class - 1].magazine_id
        }else if(key=='type'){
          if(that.Components == 'LayPeriodicalJournal'){
            obj[key] ='one'
          }else {
            obj[key] = that.queryList[that.type_class - 1].type
          }

        }else {
          obj[key] = '';
        }

        return obj;
      }, {});
      that.JournalCond = {...emptyObj};
    },
    //选择期刊、杂志分类
    getJmType(item,type){
      let that = this
      if(type=='class'){
        if(item.magazineclass_id==that.magazineclassId&&((that.Components != 'LayAllJournalList')
            ||(that.Components == 'LayAllJournalList'&&that.value_class==0))){
          that.magazineclassId = ''
          that.JournalCond.magazineclass_id = ''
        }else {
          that.magazineclassId = item.magazineclass_id
          that.JournalCond.magazineclass_id = item.magazineclass_id
        }
      }else if(type=='keymn'){
        if(item.id==that.keymnId){
          that.keymnId = ''
          that.JournalCond.keymn = ''
        }else {
          that.keymnId = item.id
          that.JournalCond.keymn = item.id
        }
      }

      that.getJournalSearch()

    },

    //分类查看更多
    getMore(untype) {
      let that = this
      that.untype = untype
      if (untype) {
        that.typeclassList = [that.type_class*1]
      } else {
        that.typeclassList = [1, 2, 3, 4, 5, 6, 7,8]
      }
      this.getWidth()
    },
    //计算宽度
    getWidth() {
      let _this = this
      _this.$nextTick(() => {
        const searchDivindex = document.querySelectorAll('.searchDiv')
        const boxindex = document.querySelectorAll('.class_Box');
        var sum = 0
        for (let i = 0; i < boxindex[0].children.length; i++) {
          sum += boxindex[0].children[i].offsetWidth
          boxindex[0].style.maxWidth = sum + 'px'
        }
        const boxJmindex = document.querySelectorAll('.class_jm_Box');
        if(boxJmindex&&boxJmindex.length){
          var jmbox = 0
          for (let i = 0; i < boxJmindex[0].children.length; i++) {
            jmbox += boxJmindex[0].children[i].offsetWidth
            boxJmindex[0].style.maxWidth = jmbox + 'px'
          }
          searchDivindex[0].style.maxWidth = (boxindex[0].clientWidth + 80 + boxJmindex[0].clientWidth) + 'px'
        }else {
          searchDivindex[0].style.maxWidth = (boxindex[0].clientWidth + 80) + 'px'
        }



      })
    },
    //点击文化分类
    getCulturalClass(Option) {
      let that = this
      if(!Option){
        return
      }
      that.searchContent = Option.label
      that.key_class = 'culture_id'
      that.value_class = Option.value
      that.type_class = 1
      that.Components = 'LayListBooks'
      that.resourceclass_id = ''
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }
      if (that.$refs.StartLanguage_select) {
        that.$refs.StartLanguage_select.setQuery(null)
      }
      if (that.$refs.EndLanguage_select) {
        that.$refs.EndLanguage_select.setQuery(null)
      }
    },
    //点击经典分类
    getResourClass(Option) {
      let that = this
      if(!Option){
        return
      }
      that.searchContent = Option.label
      that.key_class = 'resourceclass_id'
      that.value_class = Option.value
      that.type_class = 1
      that.Components = 'LayListBooks'
      that.culture_id = ''
      if (that.$refs.culture_select) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.StartLanguage_select) {
        that.$refs.StartLanguage_select.setQuery(null)
      }
      if (that.$refs.EndLanguage_select) {
        that.$refs.EndLanguage_select.setQuery(null)
      }
    },
    //获取文化分类
    queryDataCulture() {
      const _this = this
      let con = {
        slug: 'all',//文化类型标识，全部传all
      }
      _this.$httpsencrypt.post(`api/base/v3/culture/slugfind`, con)
          .then(val => {
            _this.CulturalClassList = []
            if (val.code == 200 && val.data.length) {
              _this.handelSlugData(val.data, ' ');
            } else {
              _this.CulturalClassList = []
            }
            _this.$store.commit('SET_CulturalClassList', _this.CulturalClassList)
          }).catch(err => {
      })
    },
    /************************************************************
     *
     * 处理书籍分类和文化分类的数据格式
     *
     ************************************************************/
    handelSlugData(data, label, type = null) {
      const title = label
      data.map((el, ind) => {
        let kk = {
          text: el.name_lang.mn ? `${title} ${el.name_lang.mn}` : `${title} ${el.name_lang.zh}`,
          value: type ? el.book_category_id : el.culture_type_id,
        }
        this.CulturalClassList.push(kk)
        let label=`${title}——`
        if (el.child.length !== 0) this.handelSlugData(el.child, label, type)
      })
    },
    //获取经典分类
    queryClassicCulture() {
      const _this = this
      _this.ResourceClassList = []
      let cond = {
        type: 'resourceclass'
      }
      _this.$httpsencrypt.post(`api/web/v3/bookdatadictionary/index`, cond)
          .then(val => {
            if (val.code == 200 && val.data.length) {
              val.data.forEach(it => {

                _this.ResourceClassList.push({
                  text: it.name_lang ? (it.name_lang.mn || it.name_lang.zh) : '',
                  // value: it.parameter.length ? it.parameter[0].val ? it.parameter[0].val : '' : '',
                  value: it.book_datadictionary_id,
                })
              })
              let yt = {
                text: '地方文献',
                value: 335,
              }
              _this.ResourceClassList = _this.ResourceClassList.concat(yt)
            } else {
              _this.ResourceClassList = []
            }
            _this.$store.commit('SET_ResourceClassList', _this.ResourceClassList)
          }).catch(err => {
        _this.ResourceClassList = []
      })
    },
    //  获取期刊分类
    getPeriodical() {
      const _this = this
      _this.$httpsencrypt.post(`api/web/v3/magazineclass/index`)
          .then(val => {
            if (val.code == 200 && val.data.length) {
              _this.$store.commit('SET_PeriodicalClass', val.data)
              _this.JournalClass = val.data
              val.data.forEach((item, index) => {
                _this.list_5.push({
                  titlelang: item.titlelang,
                  components: 'LayAllJournalList',
                  typeClass: 5,
                  key: 'magazineclass_id',
                  value: item.magazineclass_id
                })
              })
              _this.list_5.push({
                titlelang: {
                  mn: _this.library_infor && _this.library_infor.name_lang ? ((_this.library_infor.name_lang.mn || _this.library_infor.name_lang.zh)) : '',
                  zh: _this.library_infor && _this.library_infor.name_lang ? ((_this.library_infor.name_lang.zh || _this.library_infor.name_lang.mn)) : '',
                },
                components: 'LayPeriodicalJournal',
                typeClass: 5,
                // key: 'title',
                key: '',
                value: ''
              })
            } else {
              _this.$store.commit('SET_PeriodicalClass', [])
              _this.JournalClass = []
            }
            _this.$nextTick(() => {
              setTimeout(function () {
                _this.getWidth()
              }, 500)
            })
          }).catch(err => {
      })
    },
    //获取首字母
    getInitialList(){
      const _this = this
      _this.$http.get(`api/web/v1/Magazine/keywordlist?type=mn`)
          .then(val => {
            if (val.info.code == 200 && val.data.length) {
              _this.$store.commit('SET_InitialList', val.data)
              _this.InitialList = val.data
            } else {
              _this.$store.commit('SET_InitialList', [])
              _this.InitialList = []
            }
            _this.$nextTick(() => {
              setTimeout(function () {
                _this.getWidth()
              }, 500)
            })
          }).catch(err => {
      })
    },
    //书籍列表点击出版社进行检索
    pushTele(val) {
      let that = this
      that.showsidebar = false//关闭详情弹框
      that.searchContent = val.data
      that.key_class = 'press_name'
      that.value_class = ''
      that.type_class = 1
      that.Components = 'LayListBooks'
      that.isComponents = that.Components
      that.culture_id = ''
      that.resourceclass_id = ''
      if (that.$refs.culture_select) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }

      const emptyObj = Object.keys(that.queryList[that.type_class - 1]).reduce((obj, key) => {
        if(that.type_class==5&&key=='type'&&that.Components == 'LayPeriodicalJournal'){
          obj[key] = 'one';
        }else {
          obj[key] = '';
        }
        return obj;
      }, {});
      that.queryList[that.type_class - 1] = {...emptyObj, 'press_id': val.id};
      setTimeout(function () {
        that.$refs.child.ParentCom(that.queryList[that.type_class - 1]);
        that.$loginPd()
      }, 500)
    },
    //进入期刊列表
    goJournal(val) {
      let that = this
      that.showsidebar = false//关闭详情弹框
      that.searchContent = ''
      that.key_class = 'title'
      that.value_class = ''
      that.type_class = 5
      that.Components = 'LayListJournal'
      that.isComponents = that.Components

      that.queryList[that.type_class - 1].magazine_id = val.id
      that.queryList[that.type_class - 1].title = ''
      that.queryList[that.type_class - 1].type = val.type



      that.searchContent = ''
      that.fieldKey= 'title'
      const emptyObj = Object.keys(that.JournalCond).reduce((obj, key) => {
        if(key=='magazine_id'){
          obj[key] = val.id
        }else if(key=='type'){
          obj[key] = val.type
        }else {
          obj[key] = '';
        }

        return obj;
      }, {});
      that.JournalCond = {...emptyObj};
      that.keymnId = ''//首字母
      that.magazineclassId = ''

      that.JournalCond.type =val.type
      that.JournalCond.magazine_id =val.id


      setTimeout(function () {
        that.$refs.child.ParentCom(that.JournalCond);
        that.$loginPd()
      }, 500)
    },
    //  进到首页时恢复到原来的样子
    getClear() {
      let that = this
      that.untype = false
      that.typeclassList = [1, 2, 3, 4, 5, 6, 7,8]
      that.key_class = ''
      that.value_class = ''
      that.type_class = ''
      that.Components = ''
      that.searchContent = ''
      that.culture_id = ''
      that.resourceclass_id = ''
      that.startlanguage = ''
      that.endlanguage = ''
      if (that.$refs.culture_select) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }
      if (that.$refs.StartLanguage_select) {
        that.$refs.StartLanguage_select.setQuery(null)
      }
      if (that.$refs.EndLanguage_select) {
        that.$refs.EndLanguage_select.setQuery(null)
      }
      that.$nextTick(() => {
        setTimeout(function () {
          that.getWidth()
        }, 500)
      })
    },

    onStartSelect() {
      let that = this
      that.key_class = 'language'
      that.value_class = ''
      that.type_class = 7
      that.Components = 'LayTranslate'
      if (that.$refs.culture_select) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }
    },
    onEndSelect() {
      let that = this
      that.key_class = 'conlanguage'
      that.value_class = ''
      that.type_class = 7
      that.Components = 'LayTranslate'
      if (that.$refs.culture_select&&that.culture_id) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }
    },

    //进入详情
    getToDeatils(val, components) {
      let that = this
      that.which_to_show = components
      that.showsidebar = true
      that.titleStr = that.$t('m.details')
      that.infoId = val.id
      that.directoryId = val.directory_id
      that.$loginPd()
    },

    //获取语言
    getLang() {
      const _this = this
      let con = {
        type: 'fylanguage',//语言列表，全部传all
      }
      _this.$httpsencrypt.post(`api/web/v3/bookdatadictionary/index`, con)
          .then(val => {
            this.$store.commit('SET_langNewArr', val.data)
          }).catch(err => {
      })
    },

    //下拉框点击清空按钮事件
    onClear(){
      let that = this
      that.searchContent = ''
      that.key_class = ''
      that.value_class = ''
      that.type_class = ''
      that.Components = ''
    }
  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ?
          JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id ?
              JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : 28 : 28
      return vv
    },
    member_id() {
      let vv = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return vv
    },
    library_infor: {
      get: function () {
        let myDate = localStorage.getItem("theme_color") ?
            JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))) : ''
        return myDate;
      },
      set: function (newValue) {
        return newValue;
      },
    }
  },
  created() {
    let that = this
    that.$loginPd()
    if (this.$store.getters.CulturalClassList.length) {
      this.CulturalClassList = this.$store.getters.CulturalClassList
    } else {
      this.queryDataCulture()
    }
    if (this.$store.getters.ResourceClassList.length) {
      this.ResourceClassList = this.$store.getters.ResourceClassList
    } else {
      this.queryClassicCulture()
    }
    if (this.$store.getters.PeriodicalClass.length) {
      this.JournalClass = this.$store.getters.PeriodicalClass
      this.$store.getters.PeriodicalClass.forEach((item, index) => {
        this.list_5.push({
          titlelang: item.titlelang,
          components: 'LayAllJournalList',
          typeClass: 5,
          key: 'magazineclass_id',
          value: item.magazineclass_id
        })
      })
      this.list_5.push({
        titlelang: {
          mn: this.library_infor && this.library_infor.name_lang ? ((this.library_infor.name_lang.mn || this.library_infor.name_lang.zh)) : '',
          zh: this.library_infor && this.library_infor.name_lang ? ((this.library_infor.name_lang.zh || this.library_infor.name_lang.mn)) : '',
        },
        components: 'LayPeriodicalJournal',
        typeClass: 5,
        // key: 'title',
        key: '',
        value: ''
      })
      this.$nextTick(() => {
        setTimeout(function () {
          that.getWidth()
        }, 1000)
      })

    } else {
      this.getPeriodical()
    }
    if (!that.$store.getters.langNewArr.length) {
      that.getLang()
    }

    if (this.$store.getters.InitialList.length) {
      this.InitialList = this.$store.getters.InitialList
    } else {
      this.getInitialList()
    }


    if (this.$route.query&&this.$route.query.data) {
      let routerData = JSON.parse(this.$crypto.get(this.$route.query.data))
      this.key_class = routerData.key_class
      this.value_class = routerData.value_class
      this.type_class = routerData.type_class
      this.Components = routerData.Components
      this.searchContent = routerData.searchContent
      this.culture_id = routerData.key_class == 'culture_id' ? routerData.value_class : ''
      this.resourceclass_id = routerData.key_class == 'resourceclass_id' ? routerData.value_class : ''
      this.startlanguage = this.type_class == 7 ? routerData.startlanguage : ''
      this.endlanguage = this.type_class == 7 ? routerData.endlanguage : ''
    }
    if (this.$route.query&&this.$route.query.data) {
      let routerData = JSON.parse(this.$crypto.get(this.$route.query.data))
      this.untype = true
      this.typeclassList =routerData.type_class? [routerData.type_class*1]:[1, 2, 3, 4, 5, 6, 7,8]
    }else {
      that.untype = false
      that.typeclassList = [1, 2, 3, 4, 5, 6, 7,8]
    }
    this.$nextTick(() => {
      setTimeout(function () {
        that.getWidth()
      }, 500)
    })

  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getSearch()
      if (to.query.data&&vm.$crypto.get(to.query.data)&&JSON.parse(vm.$crypto.get(to.query.data)).type_class) {
        let routerDatatype_class = JSON.parse(vm.$crypto.get(to.query.data)).type_class
        vm.untype = true
        vm.typeclassList = [routerDatatype_class*1]
      }else {
        vm.untype = false
        vm.typeclassList = [1, 2, 3, 4, 5, 6, 7,8]
      }

    })
  }


}
</script>

<style lang="less" scoped>
#SearchIndex {
  width: 100%;
  height: 100%;
  display: flex;

  .searchDiv {
    height: 100%;
    display: flex;
    padding: 55px 0;
    padding-right: 10px;
    background: #ffffff;
    margin-right: 10px;

    .class_Box {
      height: 100%;

      .class_Item {
        height: 100%;
        border-right: 1px solid #E6EFFD;
        padding-left: 6px;

        .label {
          width: 34px;
          min-height: 63px;
          padding: 8px;
          border-radius: 4px;
          border: 1px solid var(--themeColor);
          color: #888888;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 6px;
          margin-bottom: 13px;
          float: left;
          cursor: pointer;
        }

        .active {
          width: 34px;
          min-height: 63px;
          padding: 8px;
          border-radius: 4px;
          border: 1px solid var(--themeColor);
          color: #FFB600;
          background: var(--themeColor);
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 6px;
          margin-bottom: 13px;
          float: left;
          cursor: pointer;
        }

        .label:hover {
          background: #F5F5F5;
        }

        .labelSub {
          width: 34px;
          height: 240px;
          border-radius: 4px;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 6px;
          margin-bottom: 13px;
          float: left;
          cursor: pointer;
        }

        .title_model{
          width: 34px;
          margin-bottom: 10px;
          font-size: #888888;
          font-size: 18px;
          line-height: 34px;
          float: left;
        }

      }
    }


    .class_jm_Box {
      height: 100%;
      .class__jm_Item {
        width: 48px;
        height: 100%;
        border-right: 1px solid #E6EFFD;
        padding-left: 8px;
        overflow-y: auto;
        overflow-x: hidden;

        .labeljm {
          width: 28px;
          min-height: 30px;
          padding: 8px;
          border-radius: 4px;
          border: 1px solid var(--themeColor);
          color: #888888;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 6px;
          margin-bottom: 13px;
          float: left;
          cursor: pointer;
        }

        .activejm {
          width: 28px;
          min-height: 30px;
          padding: 8px;
          border-radius: 4px;
          border: 1px solid var(--themeColor);
          color: #FFB600;
          background: var(--themeColor);
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 6px;
          margin-bottom: 13px;
          float: left;
          cursor: pointer;
        }

        .labeljm:hover {
          background: #F5F5F5;
        }

        .title_model_jm{
          width: 34px;
          margin-bottom: 10px;
          font-size: #888888;
          font-size: 18px;
          line-height: 34px;
          float: left;
        }

      }
      .class__jm_Item::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 12px;
      }
      .class__jm_Item::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }
      .class__jm_Item::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }


    .search_Box {
      width: 40px;
      height: 100%;
      margin-left: 6px;

      .textareadiv {
        width: 100%;
        //height: calc(100% - 12rem);
        //border: 1px solid #F5F5F5;


        textarea {
          width: 100%;
          height: 100%;
          font-size: 18px;
          display: table-column !important;
          color: #888888;
          background: #F5F5F5;
          text-indent: 1rem;
          resize: none;
          border: none;
          outline: none;
          overflow-x: hidden !important;
          white-space: nowrap;
          line-height: 3.3rem;
          font-weight: unset;
          font-weight: normal;
          font-family: "MGQ8102" !important;
          border-radius: 3px 3px 0 0;
        }

        textarea::-webkit-input-placeholder { /* WebKit browsers */
          line-height: 40px !important;
        }

        textarea:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
          color: #888888;
        }

        textarea::-moz-placeholder { /* Mozilla Firefox 19+ */
          color: #888888;
        }

        textarea:-ms-input-placeholder { /* Internet Explorer 10+ */
          color: #888888;
        }

      }

      .icon_s {
        width: 39px;
        height: 6rem;
        border: 1px solid var(--themeColor);
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 0 0 3px 3px;
        margin: 0 auto;
        i {
          color: var(--themeColor);
          font-size: 28px;
        }
      }

      .icon_s:hover {
        background: var(--themeColor);

        i {
          color: #FFB600;
        }
      }

      .JMlabelSub {
        width: 40px;
        line-height: 40px;
        border-radius: 4px;
        margin-bottom: 1rem;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        float: left;
        cursor: pointer;
      }

    }

    .left_right {
      width: 100%;
      height: 40px;
      padding: 8px;
      border-radius: 4px;
      border: 1px solid var(--themeColor);
      color: #888888;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-top: 10px;
    }

    .left_left_hovr:hover {
      background: #F5F5F5 !important;
      color: var(--themeColor) !important;
    }

    .left_right_hovr:hover {
      color: #FFB600 !important;
      background: var(--themeColor) !important;

    }
  }

  .mainDiv {
    //width: calc(100% - 130px);
    width: 100%;
    height: 100%;
    overflow-x: auto;
    padding: 30px 0;
    position: relative;
  }

}
</style>

<style lang="less">
#SearchIndex {
  //下拉框的样式
  .ivu-select {
    display: flex;
    position: relative !important;
  }

  .ivu-select-single .ivu-select-selection {
    width: 100% !important;
    height: 100% !important;
    border: 1px solid var(--themeColor) !important;
    //background: var(--themeColor) !important;
  }

  .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 100% !important;
    padding: 8px 0 24px 0 !important;
    font-family: "MGQ8102" !important;
    color: #FFB600 !important;
    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;
  }

  .ivu-select-placeholder {
    font-family: "MGQ8102" !important;
    color: #888888 !important;
  }

  .ivu-select-arrow {
    top: 95% !important;
    right: calc(calc(100% - 14px) / 2) !important;
    color: var(--themeColor) !important;
    writing-mode: horizontal-tb !important;
  }

  //.ivu-select .ivu-select-dropdown {
  //  top: 0px !important;
  //  left: 36px !important;
  //  will-change: left, left !important;
  //  transform-origin: left !important;
  //  height: auto !important;
  //  margin: 0 5px !important;
  //  background: var(--themeColor) !important;
  //  padding: 0 !important;
  //  max-width: 300px !important;
  //  display: inherit;
  //}

  .transfer_index_search {
    top: 0px !important;
    left: 36px !important;
    will-change: left, left !important;
    transform-origin: left !important;
    height: auto !important;
    margin: 0 5px !important;
    background: var(--themeColor) !important;
    padding: 0 !important;
    max-width: 300px !important;
    display: inherit;
  }

  .ivu-select-item {
    padding: 16px 7px !important;
    font-family: "MGQ8102" !important;
    color: #ffffff !important;
    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;
    white-space:break-spaces!important;

  }

  .ivu-select-item-selected, .ivu-select-item-selected:hover {
    background: rgba(255, 255, 255, 0.5) !important;
  }
  .ivu-select-item-focus{
    background: none;
  }

  .ivu-select .ivu-select-item:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    color: #FFB600 !important;
  }

  .ivu-select-selection {
    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;
    background: none !important;
    width: 100%;
    height: 100%;
    border: 1px solid var(--themeColor) !important;
  }

  .ivu-select-multiple .ivu-select-input {
    width: 34px !important;
    height: 100% !important;
    padding: 7px 4px !important;
    display: table-column !important;
    color: var(--themeColor) !important;
    font-size: 18px !important;
    font-family: "MGQ8102" !important;

    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;
  }

  .ivu-select-multiple .ivu-select-selection {
    padding: 0 !important;
  }

  .ivu-select-multiple .ivu-tag {
    width: 32px !important;
    height: auto !important;
    //min-height:50px!important;
    padding: 5px;
    margin: 0 auto;
    margin-bottom: 5px;
    position: unset !important;
    display: inline-flex !important;

  }

  .ivu-select-multiple .ivu-tag i {
    position: unset !important;
    width: 10px !important;
    height: 22px !important;
    margin-left: 5px !important;
    text-align: center !important;
  }

  .ivu-tag-text {
    color: var(--themeColor) !important;
    font-size: 16px !important;
    font-family: "MGQ8102" !important;
    width: 100% !important;

    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;
  }

  .ivu-select-single .ivu-select-input {
    width: 34px !important;
    height: 100% !important;
    padding: 7px 4px !important;
    display: table-column !important;
    color: var(--themeColor) !important;
    font-size: 18px !important;
    font-family: "MGQ8102" !important;
  }

  .ivu-select input::-webkit-input-placeholder { /* WebKit browsers */
    position: absolute;
    left: 5px !important;
    color: #888888;
    font-size: 18px !important;
    font-family: "MGQ8102" !important;
  }

  //级联选择器样式

  .ivu-cascader {
    height: 300px !important;
    position: relative !important;
  }

  .ivu-input-inner-container {
    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;
  }

  .ivu-cascader .ivu-input {
    width: 34px !important;
    height: 300px !important;
    padding: 7px 4px !important;
    display: table-column !important;
    border: 1px solid var(--themeColor) !important;
    background: none !important;
    color: var(--themeColor) !important;
    font-size: 18px !important;
    font-family: "MGQ8102" !important;

  }

  .ivu-cascader input::-webkit-input-placeholder { /* WebKit browsers */
    position: absolute;
    left: 5px !important;
    color: var(--themeColor);
    font-size: 18px !important;
    font-family: "MGQ8102" !important;
  }

  .ivu-cascader-arrow {
    top: 95% !important;
    right: 10px !important;
    color: var(--themeColor) !important;
  }

  .ivu-cascader .ivu-select-dropdown {
    top: 0px !important;
    left: 36px !important;
    will-change: left, left !important;
    transform-origin: left !important;
    max-height: 500px !important;
    margin: 0 5px !important;
    background: none !important;
    box-shadow: none !important;
    max-width: 300px !important;
    overflow-x: auto !important;

    div {
      width: auto !important;
      height: auto !important;
    }
  }

  .ivu-cascader-menu {
    min-width: 30px !important;
    height: auto !important;
    padding: 0 !important;
    background: var(--themeColor) !important;
    vertical-align: bottom !important;

    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;
  }

  .ivu-cascader .ivu-cascader-menu-item {
    padding: 16px 7px 32px 7px !important;
    color: #FFB600 !important;
    font-family: "MGQ8102" !important;
  }

  .ivu-cascader-menu .ivu-cascader-menu-item i {
    top: 80% !important;
    right: 10px !important;
  }

  .ivu-cascader .ivu-cascader-menu-item:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    color: #ffffff !important;
  }

  .ivu-cascader-menu .ivu-cascader-menu-item-active {
    background: rgba(255, 255, 255, 0.5) !important;
  }

}
</style>
